import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Facility } from 'models/Facility.model';
import { environment } from '../../environments/environment';
import { Observable } from 'rxjs';
import { ITimeline } from '../interfaces/timeline';
import { ITimelineItem } from '../interfaces/timelineItem';

@Injectable({
  providedIn: 'root'
})
export class AnalysisService {

  readonly rootUrl = environment.apiUrl;


  constructor(
    private http: HttpClient,
  ) { }

  getTags(): Observable<any> {
    return this.http.get(this.rootUrl + '/api/Analysis/tags');
  }

  insertFacilities(Facility: Facility): Observable<any> {
    return this.http.post(this.rootUrl + '/api/Analysis/insert', Facility);
  }

  getTimeline(analisysId, modules, currentPage, itemsNumberPerPage): Observable<ITimeline> {
    let data = {
      analisysId: analisysId,
      modules: modules,
      currentPage: currentPage,
      itemsNumberPerPage: itemsNumberPerPage
    }
    return this.http.post<ITimeline>(this.rootUrl + '/api/Analysis/timeline', data);
  }

  updateRequest(facilityId, tagId): Observable<any> {
    let data = '?facilityId=' + facilityId + '&tagId=' + tagId;
    return this.http.get(this.rootUrl + '/api/Analysis/updateRequest' + data);
  }
}
